import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';

import firstImage from '../../../assets/images/warehouse.png';
import secondImage from '../../../assets/images/information.png';
import Docmnt from '../../../assets/images/google-docs.png';
import Trash from '../../../assets/images/trash.png';
import MailGreen from '../../../assets/images/mail_green.png';  
import MailRed from '../../../assets/images/mail_red.png';
import AssetsIcon from '../../../assets/images/oparation.svg'; 
import AssetsIconw from '../../../assets/images/oparation_a.svg';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tab, Tabs, Modal, Row, Col, Button, Form, Accordion, Table, Dropdown, ButtonGroup, ToggleButton } from 'react-bootstrap';
import { faArrowLeft, faCircleXmark, faPencilAlt, faPaperclip, faFileArrowDown, faFileLines, faEllipsisVertical, faPlane, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { Step, StepLabel, Stepper } from '@mui/material';
import Select from 'react-select'
import { toast } from 'react-toastify';
import Pack from '../../../assets/images/n_package.png';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { GETAGENT, GETDESTINATION, GETOWNERCODE, SAVEHANDLER, SAVERECOVERY, STATIONHANDLER, STATIONLIST, ULDADDRESSSAVE } from '../../../Utils/conts.js';
import { saveAs } from "file-saver";
import Uploadw from '../../../assets/images/upload-w.png';
import Radown from "../../../assets/images/radown.png";
import Shipupload from "../../../assets/images/ship_upload.png";
import { set } from 'lodash';
import Uploadn from '../../../assets/images/upload-n.png';
import moment from 'moment';
import MessageBox from '../../../Components/common/MessageBox.js';
import User from "../../../assets/images/user.png";
import SettingsIcon from '../../../assets/images/settings.png';
const EditTask = () => {

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const [disLoading, setDisLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [status, setStatus] = useState(55);
    const [statusList, setStatusList] = useState([]);
    const [awbList, setAwbList] = useState([]);
    const [docList, setDocList] = useState([]);
    const [progress, setProgress] = useState(50);
    const [reason, setReason] = useState('');
    const [activeStep, setActiveStep] = useState(0);
    const [uploadTarget, setUploadTarget] = useState('');
    const fileInputRefs = useRef({});
    const [typeModal, setTypeModal] = useState(false);
    const [modalSection, setModalSection] = useState('');
    const [modalData, setModalData] = useState({});
    const [typeData, setTypeData] = useState('');
    const [departmentList, setDepartmentList] = useState([]);
    const [userList, setUserList] = useState([]);
    const userId = localStorage.getItem('UserID');
    const rowId = JSON.parse(localStorage.getItem('rowId'));
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const taskType = [
        { label: "Custom", value: "Custom" },
        { label: "Finding", value: "Finding" },
        { label: "Finding (minor)", value: "Finding (minor)" },
        { label: "Finding (Major)", value: "Finding (Major)" },
        { label: "Observation", value: "Observation" },
        { label: "Observation (minor)", value: "Observation (minor)" },
        { label: "Observation (Major)", value: "Observation (Major)" },
        { label: "Improvement opportunity", value: "Improvement opportunity" }
    ];

    const notification = [
        { label: "Due = in 3 days, Rem = the day before", value: 1, dueOffset: 3, remOffset: 1 },
        { label: "Due = in a week, Rem = two days before", value: 2, dueOffset: 7, remOffset: 2 },
        { label: "Due = two weeks, Rem = 3 days before", value: 3, dueOffset: 14, remOffset: 3 },
        { label: "Due = one month, Rem = a week before", value: 4, dueOffset: 30, remOffset: 7 },
        { label: "Due = two months, Rem = a week before", value: 5, dueOffset: 60, remOffset: 7 },
        { label: "Due = 3 months, Rem = a week before", value: 6, dueOffset: 90, remOffset: 7 },
        { label: "Custom Values (Template/Selected)", value: 7, dueOffset: 90, remOffset: 7 }
    ];

    // const handleFieldChange = (field, value) => {

    //     if (field === 'notifications') {
    //         const selected = notification?.find(opt => opt.value === parseInt(value));
    //         if (selected) {
    //             const today = moment();
    //             const dueDate = today.clone().add(selected.dueOffset, 'days').format('YYYY-MM-DDTHH:mm');
    //             const reminderDate = moment(dueDate).subtract(selected.remOffset, 'days').format('YYYY-MM-DDTHH:mm');
    //             const overdueNotif = moment(dueDate).add(1, 'days').format('YYYY-MM-DDTHH:mm');

    //             setFormData(prev => ({
    //                 ...prev,
    //                 notifications: value,
    //                 due_date: dueDate,
    //                 reminder_date: reminderDate,
    //                 overdue_notif: overdueNotif,
    //             }));
    //         } else {
    //             setFormData(prev => ({ ...prev, notifications: value }));
    //         }
    //     } else {
    //         setFormData(prev => ({ ...prev, [field]: value }));
    //     }
    // };



    const handleFieldChange = (field, value) => {
        if (field === 'notifications') {
            const selected = notification?.find(opt => opt.value === parseInt(value));
            if (selected) {
                const today = moment();
                // const dueDate = today.clone().add(selected.dueOffset, 'days').format('YYYY-MM-DDTHH:mm');
                const dueDate = today.clone().add(selected.dueOffset, 'days').format('YYYY-MM-DD');
                const reminderDate = moment(dueDate).subtract(selected.remOffset, 'days').format('YYYY-MM-DD');
                const overdueNotif = moment(dueDate).add(1, 'days').format('YYYY-MM-DD');

                setFormData(prev => ({
                    ...prev,
                    notifications: value,
                    due_date: dueDate,
                    reminder_date: reminderDate,
                    overdue_notif: overdueNotif,
                }));
            } else {
                setFormData(prev => ({ ...prev, notifications: value }));
            }

        } else if (field === 'due_date') {

            setFormData((prev) => {
                const updated = {
                    ...prev,
                    notifications: 7,
                    due_date: value,
                };
                if (updated.reminder_date) {
                    delete updated.reminder_date;
                }

                return updated;
            });
        } else if (field === 'progress') {
            const newProgress = parseInt(value);
            setProgress(newProgress);
            if (value == 0) {
                setFormData(prev => ({
                    ...prev,
                    progress: newProgress,
                    status: 55
                }));
            } else if (value == 100) {
                setFormData(prev => ({
                    ...prev,
                    progress: newProgress,
                    status: 58
                }));
            } else {
                setFormData(prev => ({
                    ...prev,
                    progress: newProgress,
                    status: 56
                }));
            }


        } else if (field === 'status') {
            const newStatus = parseInt(value);
            setStatus(newStatus);
            let newProgress = progress;

            if (newStatus === 55) {
                newProgress = 0;
                setProgress(0);
            } else if (newStatus === 56) {
                newProgress = 50;
                setProgress(50);
            } else if (newStatus === 58) {
                newProgress = 100;
                setProgress(100);
            }

            setFormData(prev => ({
                ...prev,
                status: newStatus,
                progress: newProgress
            }));

            // captureProgressAndStatus(newProgress, newStatus);

        } else {
            setFormData(prev => ({ ...prev, [field]: value }));
        }
    };


    const fetchdeparrtment = async () => {
        try {
            const res = await withRFSToken.get("/organisation-department/dropdown")
                .then(function (res) {

                    const innerData = res.data.response_data;

                    const transformData = innerData ? innerData.map((item) => ({
                        label: item.label,
                        value: item.value
                    })) : []
                    setDepartmentList(transformData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchStatus = async () => {
        try {
            const res = await withRFSToken.get("/task/get-status-dropdown")
                .then(function (res) {
                    console.log("🚀 ~ fetchStatus ~ res:", res.data.response_data);
                    const statusData = res.data.response_data;
                    const transformData = statusData ? statusData.map((item) => ({
                        label: item.label,
                        value: item.value
                    })) : [];

                    setStatusList(transformData);

                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchAwb = async () => {
        try {
            const res = await withRFSToken.post("service-recovery/all-awb-number")
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformData = innerData ? innerData.map((item) => ({
                        label: item.master_airway_bill,
                        value: item.taskable_id,
                        taskable_type: item.taskable_type
                    })) : []
                    setAwbList(transformData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchuser = async () => {
        try {
            const res = await withRFSToken.post("uld-setting/get-user-list", { status: 'A' })
                .then(function (res) {
                    const innerData = res.data.Rows;
                    const transformData = innerData ? innerData.map((item) => ({
                        label: item.first_name + ' ' + item.last_name,
                        value: item.user_id
                    })) : []
                    setUserList(transformData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDoc = async () => {
        try {
            const res = await withRFSToken.get("document/get-all-document-ref")
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformData = innerData ? innerData.map((item) => ({
                        label: item.master_airway_bill,
                        value: item.taskable_id,
                        taskable_type: item.taskable_type
                    })) : []
                    setDocList(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const [expandedKeys, setExpandedKeys] = useState([]);
    const [selectedButton, setSelectedButton] = useState('general');
    const [rfiles, setRfiles] = useState([]);
    const [sendData, setSendData] = useState({});
    // IMAGE UPLOAD START
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const [editFiles, setEditFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);
    // IMAGE UPLOAD END



    // useEffect(() => {
    //     let newStatus = status;

    //     if (progress === 0) {
    //         newStatus = 55; // Assigned
    //     } else if (progress > 0 && progress < 100) {
    //         newStatus = 57; // In progress
    //     } else if (progress === 100) {
    //         newStatus = 58;
    //     }
    //     setFormData(prev => ({
    //         ...prev,
    //         status: newStatus
    //     }));

    //     if (newStatus !== status) {
    //         setStatus(newStatus);
    //     }


    //     captureProgressAndStatus(progress, newStatus);

    // }, [progress, statusList]);


    const captureProgressAndStatus = (progressValue, statusValue) => {
        const statusLabel = statusList?.find(item => item.value === statusValue)?.label || '';

        const data = {
            progress: progressValue,
            status: statusValue,
            status_label: statusLabel,
            timestamp: new Date().toISOString()
        };

        console.log("🚀 ~ Progress & Status Data:", data);

        return data;
    };



    const loadDetails = async () => {
        // console.log("🚀 ~ loadDetails ~ rowId:", "zzzzzzzzz");

        try {
            const res = await withRFSToken.get(`task/details?id=${rowId}`)
                .then(function (res) {
                    const innerData = res.data.response_data;

                    setSelectedRowData(innerData);
                    setFormData(innerData);
                    formData.created_on = innerData.created_on ? innerData.created_on.split('T')[0].split('-').reverse().join('-') : '';
                    if (innerData.progress !== undefined) {
                        setProgress(innerData.progress);
                    }

                    if (innerData.status !== undefined) {
                        setStatus(innerData.status);
                    }

                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        fetchdeparrtment();
        fetchuser();
        loadDetails();
        fetchStatus()
        fetchAwb();
        fetchDoc();
        isMounted.current = true;
    }, []);

    // IMAGE UPLOAD START
    const [isTopDel, setIsTopDel] = useState(false);


    // const handleBrowseFiles = (e) => {
    //     e.preventDefault();
    //     fileInputRef.current.click();
    // };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    // image select
    const [selectedKeys, setSelectedKeys] = useState([]);

    const handleImageSelect = (key, data) => {
        console.log("🚀 ~ handleImageSelect ~ data:", data)

        if (formData.files) {
            const extension = data?.name?.split('.').pop().toLowerCase();
            if (["jpeg", "jpg", "png", "webp"].includes(extension)) {
                setFormData((prevFormData) => {
                    const updatedFiles = prevFormData.files.map((file, index) => {
                        if (index === key) {
                            // Toggle the "primary" field for the selected file
                            return {
                                ...file,
                                primary: file.primary === 1 ? 0 : 1,
                            };
                        }
                        return file;
                    });

                    return {
                        ...prevFormData,
                        files: updatedFiles,
                    };
                });
                // setFiles((prevFiles) =>
                //     prevFiles.map((file, index) =>
                //         index === key
                //             ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
                //             : file // Leave other files unchanged
                //     )
                // );
                setSelectedKeys((prevSelected) =>
                    prevSelected.includes(key)
                        ? prevSelected.filter((selectedKey) => selectedKey !== key) // Remove key if already selected
                        : [...prevSelected, key] // Add key if not selected
                );
            }
        }
        if (["jpeg", "jpg", "png", "webp"].includes(data?.file_type)) {

            setEditFiles((prevFiles) =>
                prevFiles.map((file) =>
                    file.id === data.id
                        ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
                        : file // Leave other files unchanged
                )
            );
        }

    };

    // ===============================================code  24.06.2025=================================================
    const [activeTab, setActiveTab] = useState('All');

    const handleButtonClick = async (button) => {
        if (button == 'remarks') { setActiveStep(2) }
        else if (button == 'attachment') {
            setActiveStep(1);
            if (!formData.id && formData.master_airwaybill) {
                try {
                    const res = await withRFSToken.post('shipment/save-import-shipment-record', formData);
                    // console.log('API Response:', res.data);
                    if (res.data.response_code === 200) {
                        localStorage.setItem('SHEdit', JSON.stringify(res.data.response_data.id));
                        setFormData(res.data.response_data);
                    }
                } catch (error) {
                    console.error('Error saving shipment record:', error);
                }
            }
        }
        else { setActiveStep(0) }
        setSelectedButton(button);
    };

    const toggleAccordionItem = async (index, msg, pos) => {

        setExpandedKeys(prevKeys =>
            prevKeys.includes(index.toString())
                ? prevKeys.filter(key => key !== index.toString()) // Remove key to collapse
                : [...prevKeys, index.toString()] // Add key to expand
        );
    };

    function extractPath(url) {
        try {
            let urlObject = new URL(url);
            let path = urlObject.pathname.substring(1);
            return path;
        } catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    }
    const handleDownload = async (imageUrl, imageName) => {
        const path = extractPath(imageUrl);
        const res = await withRFSToken
            .post("get-file-blob", {
                file_path: path,
            })
            .then((response) => {
                const pdfData = atob(response.data.response_data.file_base64);
                const byteNumbers = new Array(pdfData.length);
                for (let i = 0; i < pdfData.length; i++) {
                    byteNumbers[i] = pdfData.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: response.data.response_data.mime_type,
                });
                saveAs(blob, imageName);
            })
            .catch((error) => {
                console.error("Error during the file download:", error);
                alert("Could not download the file");
            });
    };

    const conversationChange = (event) => {
        const { name, value, } = event.target;
        setSendData(prevFormData => {
            const newFormData = { ...prevFormData, [name]: value };

            return newFormData;
        });
    }

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
    }

    // IMAGE UPLOAD START
    const imageModalUpload = () => {
        setShowModalUpload(true);
    }
    const closeModalUpload = () => {
        setShowModalUpload(false);
        setFiles([])
        setBase64Files([])
    }
    const handleDrop = (e) => {
        e.preventDefault();
        console.log('E', e);

        const droppedFiles = Array.from(e.dataTransfer.files);
        const selectedFiles = Array.from(e.dataTransfer.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = async () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    let newBase64Files;
                    if (uploadTarget) {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [uploadTarget] }));
                    } else {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    }
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];

                    // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files(mergedBase64Files);
                    setSendData((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, attachments: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
        // setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        // getBase64(droppedFiles[0]);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index, pos) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        if (pos == 'R') {
            setRfiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
        }
        // base64Files.splice(index, 1);
        setBase64Files((prevBase64Files) => {
            const newBase64Files = [...prevBase64Files];
            newBase64Files.splice(index, 1);
            if (pos == 'R') {

                setSendData((prevFormData) => {
                    // const newFiles = [...prevFormData.files];
                    const newFiles = Array.isArray(prevFormData.files) ? [...prevFormData.files] : [];
                    newFiles.splice(index, 1);
                    return { ...prevFormData, files: newFiles };
                });
            }
            // Update local storage


            return newBase64Files;
        });
    };

    const handleBrowseFiles = (e, nam) => {
        e.preventDefault();
        console.log('fileInputRef.current', fileInputRef);
        if (nam) {
            if (fileInputRefs.current[nam]) {
                fileInputRefs.current[nam].click();
            }
        } else { fileInputRef.current.click(); }
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }


    const handleFileChange = (e, pos, chk) => {

        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = async () => {
                if (file.size > 26214400) {
                    toast.error(`${file.name} is too large. Maximum file size is 25MB.`);
                    return;
                }
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name, type: file.type });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    // if (pos === 'C') { // pos === 'A' || 
                    //     // const newFiles = filesWithBase64.map((obj) => obj.file);
                    //     // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    //     const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }));
                    //     const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    //     // setFiles(newFiles);


                    //     const payload = {
                    //         shipmen_id: formData.id,
                    //         shipmen_type: "export",
                    //         attachments: mergedBase64Files
                    //     }
                    //     // console.log('payload', payload);
                    //     try {
                    //         const res = await withRFSToken.post('shipment/upload-doc', payload);
                    //         console.log('API Response:', res.data);
                    //         if (res.data.response_code === 200) {
                    //             toast.success(res.data.response_msg);
                    //             setFormData(res.data.response_data);
                    //         } else {
                    //             toast.error(res.data.response_msg);
                    //         }
                    //     } catch (error) {
                    //         console.error('Error saving shipment record:', error);
                    //     }

                    // } else {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    console.log("🚀 ~ reader.onloadend= ~ newFiles:", filesWithBase64);
                    let newBase64Files;
                    if (pos === 'C') {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }));
                    } else {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    }
                    console.log('newBase64Files', newBase64Files);

                    // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];

                    // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files(mergedBase64Files);
                    if (pos == 'R') {
                        setRfiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, type: obj.type }))]);
                        setSendData((prevFormData) => {
                            // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                            const newFormData = { ...prevFormData, attachments: mergedBase64Files };

                            return newFormData;
                        });
                    }

                    // }
                }
            };
            reader.readAsDataURL(file);
        });


    };
    const imageUpload = async () => {
        // setGridSelect(prevGridSelect =>
        //     prevGridSelect.map(item => {
        //         if (item.uid === selectedRowId) {
        //             return { ...item, files: files, base64Files: base64Files };
        //         }
        //         return item;
        //     })
        // );
        // setShowModalUpload(false);
        const payload = {
            attachable_id: rowId,
            attachable_type: "task_management",
            files: base64Files
        }
        // console.log('payload', payload);

        try {
            const res = await withRFSToken.post('attachment-save', payload);
            console.log('API Response:', res.data);
            if (res.data.response_code === 200) {
                toast.success(res.data.response_msg);
                setFormData(res.data.response_data);
                setShowModalUpload(false);
                setFiles([])
                setUploadTarget('');
                setBase64Files([]);
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error saving shipment record:', error);
        }
    };
    // IMAGE UPLOAD END

    const handleOpenModal = (pos, data) => {
        setModalData(data);
        setTypeModal(true);
        setModalSection(pos);
        setTypeData(data.category[0])
    }

    const modalChange = (e) => {
        setTypeData(e.target.value);
    }



    const modalUpdate = async () => {
        if (modalSection === 'S') {
            if (typeData !== null) {
                const payload = {
                    attachable_id: rowId,
                    attachable_type: 'task_management',
                    action_type: 'update',
                    file_id: modalData.file_id,
                    category: [typeData]
                }
                // console.log(payload);
                try {
                    const res = await withRFSToken.post('shipment/update-doc', payload);
                    if (res.data.response_code === 200) {
                        setFormData(res.data.response_data);
                        toast.success(res.data.response_msg)
                        setTypeModal(false);
                    } else {
                        toast.error(res.data.response_msg)
                    }
                } catch (error) {
                    console.error('Error saving shipment record:', error);
                }
            } else {
                toast.error('Please change the type first')
            }
        } else {
            const payload = {
                attachable_id: rowId,
                attachable_type: 'task_management',
                action_type: 'update',
                file_id: modalData.file_id,
                category: [typeData]
            }
            // console.log(payload);
            try {
                const res = await withRFSToken.post('shipment/update-doc', payload);
                if (res.data.response_code === 200) {
                    setFormData(res.data.response_data);
                    toast.success(res.data.response_msg)
                    setTypeModal(false);
                } else {
                    toast.error(res.data.response_msg)
                }
            } catch (error) {
                console.error('Error saving shipment record:', error);
            }
        }

    }
    const handleSave = async () => {
        setDisLoading(true);
        console.log("🚀 ~ handleSave ~ formData:", formData);
        try {
            const res = await withRFSToken.post("task/add-update", formData);
            if (res.data.response_code == 200) {

                toast.success(res.data.response_msg);
                window.location.href = '/ServiceRecovery';

            } else {

                toast.error(res.data.response_msg);
            }
            setDisLoading(false);
        } catch (error) {
            console.error('Error sending request:', error);
            setDisLoading(false);
        }

    }
    const statusMap = {
        assigned: 55,
        on_hold: 56,
        in_progress: 57,
        completed: 58,
        failed: 59,
    };
    const isStepCompleteByStatus = (statusKey) => {
        return formData.status == statusMap[statusKey];
    };

    const handleShow = () => setShowModal(true);

    const handleApply = () => {
        setShowModal(false);

    }
    return (
        <>
            {/* {console.log("🚀 ~ EditTask ~ formData:", formData)}; */}
            <div className="">
                <Header page_type='srecovery' logo_url='/ServiceRecovery' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <Link to='/ServiceRecovery' className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>

                        <div className='shipment_tab'>
                            <div className="mt-3 ">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="viewbooks" style={{}}>
                                            <h4 className='d-flex align-items-center justify-content-between'>Edit Task - {formData.title} <span onClick={() => handleSave()} ><button><FontAwesomeIcon icon={faPaperPlane} className='pe-1' />SAVE</button></span></h4>
                                            <p>
                                                <span><b>Created On :</b> {formData?.created_on?.split('T')[0].split('-').reverse().join('-')}  </span>

                                                <span><b>Created by :</b> {formData?.created_by}</span>
                                            </p>
                                            <p>
                                                <span><b>Due Date :</b> {formData?.due_date ? moment(formData.due_date).format('DD-MM-YYYY') : ''}</span>
                                                <span><b>Status: <span style={{ color: '#FC8430' }}>{formData?.status_label}</span></b></span>
                                            </p>
                                            {/* <p className='d-flex justify-content-between'><span><b>Status: <span style={{ color: '#FC8430' }}>{formData?.status_label}</span></b></span></p> */}
                                            {/* <span><b>Storage Location: <span>AMS_asd</span></b></span></p> */}
                                        </div>

                                    </div>

                                    <div className="col-md-9">
                                        <div className="viewbooks" style={{}}>
                                            {/* Progress Bar */}
                                            <div className="mt-1">
                                                <div className="d-flex justify-content-between align-items-start position-relative">

                                                    <div className="Progress_Line" style={{ backgroundColor: '#ccc' }}></div>
                                                    <div className="Progress_Line" style={{ backgroundColor: '#ccc' }}></div>

                                                    {/* Step 1 - Assigned */}
                                                    <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                                        <div className={formData.status === 55 ? "step_complete" : "step_incomplete"}>
                                                            1
                                                        </div>
                                                        <div className={formData.status === 55 ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt_incomplete'}>
                                                            <div>Assigned</div>
                                                            <div>{formData.eta ? formData.eta.replace('T', ' ') : ''}</div>
                                                        </div>
                                                    </div>

                                                    {/* Step 2 - In progress */}
                                                    <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                                        <div className={formData.status === 56 ? "step_complete" : "step_incomplete"}>
                                                            2
                                                        </div>
                                                        <div className={formData.status === 56 ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt_incomplete'}>
                                                            <div>In progress</div>
                                                            <div>{formData.ata ? formData.ata.replace('T', ' ') : ''}</div>
                                                        </div>
                                                    </div>

                                                    {/* Step 3 - On hold */}
                                                    <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                                        <div className={formData.status === 57 ? "step_complete" : "step_incomplete"}>
                                                            3
                                                        </div>
                                                        <div className={formData.status === 57 ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt_incomplete'}>
                                                            <div>On hold</div>
                                                            <div>{formData.on_hold_date ? formData.on_hold_date.replace('T', ' ') : ''}</div>
                                                        </div>
                                                    </div>

                                                    {/* Step 4 - Completed */}
                                                    <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                                        <div className={formData.status === 58 ? "step_complete" : "step_incomplete"}>
                                                            4
                                                        </div>
                                                        <div className={formData.status === 58 ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt_incomplete'}>
                                                            <div>Completed</div>
                                                            <div>{formData.pickup_airline || ''}</div>
                                                        </div>
                                                    </div>

                                                    {/* Step 5 - Failed */}
                                                    <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                                        <div className={formData.status === 59 ? "step_complete" : "step_incomplete"}>
                                                            5
                                                        </div>
                                                        <div className={formData.status === 59 ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt_incomplete'}>
                                                            <div>Failed</div>
                                                            <div>{formData.warehouse_in || ''}</div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div >

                            {disLoading &&
                                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                            }

                            {isLoading ? <><div className='mvt loader-container h-100'><span className='mvt loader' style={{ left: '48%', top: '48%' }}></span></div></> : ''}

                            <Row className='mt-3'>
                                <Col sm='3'>
                                    <div className='add_shipment'>
                                        <button className={selectedButton === 'general' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('general')}>
                                            <img src={selectedButton === 'general' ? AssetsIconw : AssetsIcon} /> <span>General</span>
                                        </button>
                                        <button className={selectedButton === 'attachment' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('attachment')}>
                                            <img src={selectedButton === 'attachment' ? AssetsIconw : AssetsIcon} /> <span>Attachments</span>
                                        </button>
                                        <button className={selectedButton === 'remarks' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('remarks')}>
                                            <img src={selectedButton === 'remarks' ? AssetsIconw : AssetsIcon} /> <span>Remarks ({formData?.remarks?.length || 0})</span>
                                        </button>
                                    </div>


                                    {/* {selectedButton === 'attachment' &&
                                        <div className='flbg mt-4'>

                                            <div className="ship_head">
                                                <h4>Document Checklist</h4>
                                            </div>
                                            <ul className="dock_check">
                                                {["Invoice", "Packinglist", "Emails", "HAWB", "MAWB", "Manifest", "Customs", "Proposal", "Other"].map((name) => (
                                                    <li key={name}>
                                                        <span>
                                                            <Form.Check
                                                                inline
                                                                label={name}
                                                                value={name}
                                                                
                                                                name="group1"
                                                                
                                                                checked={formData?.attachments?.some(chk => chk.category && chk.category.includes(name)) || false}
                                                            />
                                                        </span>
                                                        <span>
                                                          
                                                            <img src={Uploadn} onClick={() => { setUploadTarget(name); setShowModalUpload(true); }} />
                                                           
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    } */}
                                    {selectedButton === 'general' && (
                                        <>
                                            <div className='flbg mt-4'>
                                                <div className='ship_head'>
                                                    <h4>History</h4>
                                                </div>
                                                {formData?.activities?.history?.map((item) => (
                                                    <div key={item.history_id} className='d-flex align-items-center racomment'>
                                                        <div className='coment_img'>
                                                            <img src={User} alt="User" />
                                                        </div>
                                                        <div className='w-100'>
                                                            <div className='d-flex justify-content-between'>
                                                                <span className='admin-name-1'>
                                                                    {item.created_by}
                                                                </span>
                                                                <span>
                                                                    {new Date(item.created_at).toLocaleString('en-GB', {
                                                                        day: '2-digit',
                                                                        month: '2-digit',
                                                                        year: 'numeric',
                                                                        hour: '2-digit',
                                                                        minute: '2-digit',
                                                                    })}
                                                                </span>
                                                            </div>
                                                            <div className=''>
                                                                <span>{item.description}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    )}



                                </Col>
                                <Col sm='9'>

                                    {selectedButton === 'general' &&

                                        <Row>
                                            <Col lg={6} className=' mb-3'>
                                                <div className='flbg details h-100'>
                                                    <div className='ship_head'>
                                                        <h4>Assign and Due date</h4>
                                                        <img src={SettingsIcon} alt="Settings" style={{ width: '20px', height: '20px', cursor: 'pointer' }} onClick={handleShow} />
                                                    </div>
                                                    <ul className="list-unstyled">

                                                        <li>
                                                            <span>Assign to :</span>
                                                            <span>
                                                                <div className="">
                                                                    <Form.Check
                                                                        inline
                                                                        label="Myself"
                                                                        name="assign_to"
                                                                        type="radio"
                                                                        id="assign-to-myself"
                                                                        value="60"
                                                                        checked={formData?.assign_to == '60'}
                                                                        onChange={(e) => handleFieldChange('assign_to', e.target.value)}
                                                                    />
                                                                    <Form.Check
                                                                        inline
                                                                        label="A person"
                                                                        name="assign_to"
                                                                        type="radio"
                                                                        id="assign-to-person"
                                                                        value="61"
                                                                        checked={formData?.assign_to == '61'}
                                                                        onChange={(e) => handleFieldChange('assign_to', e.target.value)}
                                                                    />
                                                                    <Form.Check
                                                                        inline
                                                                        label="Department"
                                                                        name="assign_to"
                                                                        type="radio"
                                                                        id="assign-to-department"
                                                                        value="62"
                                                                        checked={formData?.assign_to == '62'}
                                                                        onChange={(e) => handleFieldChange('assign_to', e.target.value)}
                                                                    />
                                                                </div>
                                                            </span>
                                                        </li>

                                                        {(formData.assign_to == '61' || formData.assign_to == '62') && (
                                                            <li>
                                                                <span>Department :</span>
                                                                <span>
                                                                    <Select
                                                                        options={departmentList}
                                                                        value={departmentList?.find(option => option.value == formData?.department_id) || null}
                                                                        onChange={selected => handleFieldChange('department_id', selected ? selected.value : '')}
                                                                        placeholder="Select department"
                                                                        isClearable
                                                                    />
                                                                </span>
                                                            </li>
                                                        )}

                                                        {formData.assign_to == '60' &&

                                                            <li>
                                                                <span>Assigned user</span>
                                                                <span>
                                                                    <Select
                                                                        options={userList}
                                                                        onChange={selected => setFormData({
                                                                            ...formData,
                                                                            assigned_user_id: selected ? selected.value : ''
                                                                        })}
                                                                        placeholder="Select user"
                                                                        className=''
                                                                        name="assigned_user_id"
                                                                        value={userList?.find(option =>
                                                                            String(option.value) === String(formData?.assigned_user_id)
                                                                        ) || null}
                                                                        isClearable
                                                                        isDisabled={formData.assign_to == 60} // && formData?.assigned_user_id == userId
                                                                    />
                                                                </span>
                                                            </li>
                                                        }
                                                        {formData.assign_to == '61' && (
                                                            <li>
                                                                <span>Assigned user</span>
                                                                <span>

                                                                    <Select
                                                                        options={userList}
                                                                        onChange={selected => setFormData({ ...formData, assigned_user_id: selected ? selected.value : '' })}
                                                                        placeholder="Select user"
                                                                        disabled={formData.assign_to == '60'}
                                                                        className=''
                                                                        name="assigned_user_id"
                                                                        value={userList?.find(option => option.value === formData?.assigned_user_id) || null}
                                                                        isClearable
                                                                    />
                                                                </span>
                                                            </li>
                                                        )}

                                                        {/* <li>
                                                            <span>Task type :</span>
                                                            <span>
                                                                <Form.Select
                                                                    aria-label="Default select example"
                                                                    name="task_type"
                                                                    value={formData.task_type}
                                                                    onChange={(e) => handleFieldChange('task_type', e.target.value)}
                                                                    className='down_selct'
                                                                >
                                                                    {taskType.map(option => (
                                                                        <option key={option.value} value={option.value}>
                                                                            {option.label}
                                                                        </option>
                                                                    ))}
                                                                </Form.Select>
                                                            </span>
                                                        </li> */}

                                                        {/* <li>
                                                            <span>Document ref :</span>
                                                            <span>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="document_ref"
                                                                    placeholder="Document ref"
                                                                    value={formData?.document_ref}
                                                                    onChange={(e) => handleFieldChange('document_ref', e.target.value)}
                                                                />
                                                            </span>
                                                        </li> */}

                                                        <li>
                                                            <span>Due date:</span>
                                                            <span className='d-inline-flex'>
                                                                <Form.Control
                                                                    type="date"
                                                                    name="due_date"
                                                                    value={formData?.due_date || ''}
                                                                    onChange={(e) => handleFieldChange('due_date', e.target.value)}
                                                                    style={{ maxWidth: '150px', marginRight: '10px' }}
                                                                />
                                                                <Form.Select
                                                                    aria-label="Default select example"
                                                                    name="notifications"
                                                                    value={notification?.find(not => not.value == Number(formData?.notifications))?.value}
                                                                    onChange={(e) => handleFieldChange('notifications', e.target.value)}
                                                                    style={{ maxWidth: '100%' }}
                                                                >
                                                                    <option value="">(Quick setup the Due & Reminder dates)</option>
                                                                    {notification.map((opt) => (
                                                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                    ))}
                                                                </Form.Select>
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span>Assign to Recovery :</span>
                                                            <span>
                                                                <Select
                                                                    options={awbList}
                                                                    value={awbList?.find(option => option.value == formData?.taskable_id) || null}
                                                                    onChange={selected => setFormData({
                                                                        ...formData,
                                                                        taskable_id: selected?.value,
                                                                        taskable_type: selected?.taskable_type,
                                                                    })}
                                                                    placeholder="Select AWB"
                                                                    isClearable
                                                                />
                                                            </span>
                                                        </li>
                                                        {/* <li>
                                                            <span>Document Ref. :</span>
                                                            <span>
                                                                <Select
                                                                    options={docList}
                                                                    value={docList?.find(option => option.value == formData?.documentable_id) || null}
                                                                    onChange={selected => setFormData({
                                                                        ...formData,
                                                                        documentable_id: selected?.value,
                                                                        // documentable_type: selected?.documentable_type,
                                                                    })}
                                                                    placeholder="Select Ref"
                                                                />
                                                            </span>
                                                        </li> */}
                                                    </ul>
                                                </div>
                                            </Col>
                                            <Col lg={6} className='mb-3'>
                                                <div className="flbg details h-100">
                                                    <div className='ship_head'>
                                                        <h4>Progress update</h4>

                                                    </div>


                                                    <ButtonGroup className="w-100 mb-3 status-tabs">
                                                        {statusList.map((radio, idx) => (
                                                            <ToggleButton
                                                                key={idx}
                                                                id={`radio-${idx}`}
                                                                type="radio"
                                                                variant="outline-secondary"
                                                                name="status"
                                                                value={radio.value}
                                                                checked={status === radio.value}
                                                                onChange={(e) => handleFieldChange('status', e.target.value)}
                                                                className={status === radio.value ? 'active-tab' : ''}
                                                            >
                                                                {radio.label}
                                                            </ToggleButton>
                                                        ))}
                                                    </ButtonGroup>
                                                    <Form.Group as={Row} className="align-items-center">
                                                        <Form.Label column sm="2">Progress:</Form.Label>
                                                        <Col sm="7">
                                                            <Form.Range
                                                                name="progress"
                                                                min="0"
                                                                max="100"
                                                                value={progress}
                                                                onChange={(e) => handleFieldChange('progress', e.target.value)}
                                                            />
                                                        </Col>
                                                        <Col sm="3">
                                                            <Form.Control value={`${progress}%`} readOnly disabled={formData.status === 58} />
                                                        </Col>
                                                    </Form.Group>

                                                    <Form.Group>
                                                        <Form.Label>Update reason:</Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={3}
                                                            value={reason}
                                                            onChange={(e) => setReason(e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </div>
                                            </Col>

                                            <Col lg={12} className='mb-3'>
                                                <div className='flbg details h-100'>
                                                    <div className='ship_head'>
                                                        <h4>Details Discription</h4>
                                                    </div>
                                                    <MessageBox
                                                        value={formData.content || ''}
                                                        onMessageChange={content => handleFieldChange('content', content)}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                    {selectedButton === 'attachment' &&
                                        <>
                                            <div className='flbg'>
                                                <div className='all_file mb-3'>
                                                    <h4>All files</h4>
                                                    <Button variant="primary" onClick={imageModalUpload}> <img src={Uploadw} /> Upload file</Button>
                                                    <input
                                                        type="file"
                                                        ref={fileInputRef}
                                                        style={{ display: "none" }}
                                                        onChange={(e) => handleFileChange(e, 'A')}
                                                        multiple
                                                    />
                                                </div>
                                                <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="attach_tab">
                                                    <Tab eventKey="All" title={<span>View All </span>} className='moveto'>
                                                        <Table className='record_table'>
                                                            <thead>
                                                                <tr>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th>File Name</th>
                                                                    <th>Type</th>
                                                                    <th>Uploaded by</th>
                                                                    <th>last modified</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {formData.attachments?.map((data, index) => {
                                                                    const fileName = data.file_name;
                                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                    const extension = fileName?.split(".").pop();

                                                                    return (
                                                                        <tr>
                                                                            <td>
                                                                                <Form.Check // prettier-ignore
                                                                                    type="checkbox"
                                                                                    id="checkbox"
                                                                                // checked={selectedRows.some(
                                                                                //     (row) => row.attachment_id === file.id
                                                                                // )}
                                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                                />
                                                                            </td>
                                                                            <td className="delimg">
                                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                                            </td>
                                                                            <td><div className='file_attch'>
                                                                                {["jpeg", "jpg", "png", "webp"].includes(data.file_path?.split(".")[data.file_path?.split(".").length - 1]
                                                                                ) ? (
                                                                                    <>
                                                                                        <div className='file_icon'>
                                                                                            <img
                                                                                                src={data.file_path}
                                                                                                alt="Preview"
                                                                                                style={{
                                                                                                    maxWidth: "22px",
                                                                                                    maxHeight: "22px",
                                                                                                    marginRight: "10px",
                                                                                                }}
                                                                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                            // onClick={() => handleFileClick(data.file_path)}
                                                                                            />
                                                                                        </div>
                                                                                        <div className='file_text'>
                                                                                            <p>{baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 20)}... .${extension}`}</p>
                                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                                        </div>
                                                                                        {/* <span> */}
                                                                                        {/*data.file_name*/}
                                                                                        {/* {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`} */}
                                                                                        {/* </span> */}

                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <div className='file_icon'>
                                                                                            <FontAwesomeIcon icon={faFileLines} />
                                                                                        </div>
                                                                                        <div className='file_text'>
                                                                                            <p>{data.file_name}</p>
                                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                                        </div>
                                                                                        {/* <span className="d-flex rafilename">
                                                                                                                    <img src={Docmnt} className="fileimg" />
                                                                                                                    <span>{data.file_name}</span>
                                                                                                                </span> */}
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                                {/* <div className='file_attch'>
                                                                                                            <div className='file_icon'>
                                                                                                                <FontAwesomeIcon icon={faFileLines} />
                                                                                                            </div>
                                                                                                            <div className='file_text'>
                                                                                                                <p>{data.file_name}</p>
                                                                                                                <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                                                            </div>
                                                                                                        </div> */}
                                                                            </td>
                                                                            <td><p>{data.category[0]}</p></td>
                                                                            <td>
                                                                                <p>{data.modified_name}</p>
                                                                                <span>{data.modified_email}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span>{data.last_modified}</span>
                                                                            </td>
                                                                            <td>
                                                                                <Dropdown>
                                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic" disabled={data.remarks_attachment === 1}>
                                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                                    </Dropdown.Toggle>

                                                                                    <Dropdown.Menu>
                                                                                        {/* <Dropdown.Item href="#/action-1">Edit</Dropdown.Item> */}
                                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                                        {/* <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item> */}
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </Table>
                                                    </Tab>
                                                    <Tab eventKey="Documents" title={<span>Documents </span>} className='moveto'>
                                                        <Table className='record_table'>
                                                            <thead>
                                                                <tr>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th>File Name</th>
                                                                    <th>Type</th>
                                                                    <th>Uploaded by</th>
                                                                    <th>last modified</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {formData.attachments?.filter(data => ["doc", "docx", "txt"].includes(data.file_ext.toLowerCase()))
                                                                    .map((data, index) => (
                                                                        <tr>
                                                                            <td>
                                                                                <Form.Check // prettier-ignore
                                                                                    type="checkbox"
                                                                                    id="checkbox"
                                                                                // checked={selectedRows.some(
                                                                                //     (row) => row.attachment_id === file.id
                                                                                // )}
                                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                                />
                                                                            </td>
                                                                            <td className="delimg">
                                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                                            </td>
                                                                            <td>
                                                                                <div className='file_attch'>
                                                                                    <div className='file_icon'>
                                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                                    </div>
                                                                                    <div className='file_text'>
                                                                                        <p>{data.file_name}</p>
                                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td><p>{data.category[0]}</p></td>
                                                                            <td>
                                                                                <p>{data.modified_name}</p>
                                                                                <span>{data.modified_email}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span>{data.last_modified}</span>
                                                                            </td>
                                                                            <td>
                                                                                <Dropdown>
                                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                                    </Dropdown.Toggle>

                                                                                    <Dropdown.Menu>
                                                                                        {/* <Dropdown.Item href="#/action-1">Edit</Dropdown.Item> */}
                                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                        </Table>
                                                    </Tab>
                                                    <Tab eventKey="Spreadsheets" title={<span>Spreadsheets </span>} className='moveto'>
                                                        <Table className='record_table'>
                                                            <thead>
                                                                <tr>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th>File Name</th>
                                                                    <th>Type</th>
                                                                    <th>Uploaded by</th>
                                                                    <th>last modified</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {formData.attachments?.filter(data => ["xls", "xlsx", "csv"].includes(data.file_ext.toLowerCase()))
                                                                    .map((data, index) => (
                                                                        <tr>
                                                                            <td>
                                                                                <Form.Check // prettier-ignore
                                                                                    type="checkbox"
                                                                                    id="checkbox"
                                                                                // checked={selectedRows.some(
                                                                                //     (row) => row.attachment_id === file.id
                                                                                // )}
                                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                                />
                                                                            </td>
                                                                            <td className="delimg">
                                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                                            </td>
                                                                            <td>
                                                                                <div className='file_attch'>
                                                                                    <div className='file_icon'>
                                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                                    </div>
                                                                                    <div className='file_text'>
                                                                                        <p>{data.file_name}</p>
                                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td><p>{data.category[0]}</p></td>
                                                                            <td>
                                                                                <p>{data.modified_name}</p>
                                                                                <span>{data.modified_email}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span>{data.last_modified}</span>
                                                                            </td>
                                                                            <td>
                                                                                <Dropdown>
                                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                                    </Dropdown.Toggle>

                                                                                    <Dropdown.Menu>
                                                                                        {/* <Dropdown.Item href="#/action-1">Edit</Dropdown.Item> */}
                                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                        </Table>
                                                    </Tab>
                                                    <Tab eventKey="pdfs" title={<span>PDF's </span>} className='moveto'>
                                                        <Table className='record_table'>
                                                            <thead>
                                                                <tr>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th>File Name</th>
                                                                    <th>Type</th>
                                                                    <th>Uploaded by</th>
                                                                    <th>last modified</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {formData.attachments?.filter(data => ["pdf"].includes(data.file_ext.toLowerCase()))
                                                                    .map((data, index) => (
                                                                        <tr>
                                                                            <td>
                                                                                <Form.Check // prettier-ignore
                                                                                    type="checkbox"
                                                                                    id="checkbox"
                                                                                // checked={selectedRows.some(
                                                                                //     (row) => row.attachment_id === file.id
                                                                                // )}
                                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                                />
                                                                            </td>
                                                                            <td className="delimg">
                                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                                            </td>
                                                                            <td>
                                                                                <div className='file_attch'>
                                                                                    <div className='file_icon'>
                                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                                    </div>
                                                                                    <div className='file_text'>
                                                                                        <p>{data.file_name}</p>
                                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td><p>{data.category[0]}</p></td>
                                                                            <td>
                                                                                <p>{data.modified_name}</p>
                                                                                <span>{data.modified_email}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span>{data.last_modified}</span>
                                                                            </td>
                                                                            <td>
                                                                                <Dropdown>
                                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                                    </Dropdown.Toggle>

                                                                                    <Dropdown.Menu>
                                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                        </Table>
                                                    </Tab>
                                                    <Tab eventKey="Images" title={<span>Images </span>} className='moveto'>
                                                        <Table className='record_table'>
                                                            <thead>
                                                                <tr>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th>File Name</th>
                                                                    <th>Type</th>
                                                                    <th>Uploaded by</th>
                                                                    <th>last modified</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {formData.attachments?.filter(data => ["jpg", "jpeg", "png", "bmp"].includes(data.file_ext.toLowerCase()))
                                                                    .map((data, index) => {
                                                                        const fileName = data.file_name;
                                                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                        const extension = fileName?.split(".").pop();

                                                                        return (
                                                                            <tr>
                                                                                <td>
                                                                                    <Form.Check // prettier-ignore
                                                                                        type="checkbox"
                                                                                        id="checkbox"
                                                                                    // checked={selectedRows.some(
                                                                                    //     (row) => row.attachment_id === file.id
                                                                                    // )}
                                                                                    // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                                    />
                                                                                </td>
                                                                                <td className="delimg">
                                                                                    <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                                                </td>
                                                                                <td>
                                                                                    <div className='file_attch'>
                                                                                        <div className='file_icon'>
                                                                                            <img
                                                                                                src={data.file_path}
                                                                                                alt="Preview"
                                                                                                style={{
                                                                                                    maxWidth: "22px",
                                                                                                    maxHeight: "22px",
                                                                                                    marginRight: "10px",
                                                                                                }}
                                                                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                            // onClick={() => handleFileClick(data.file_path)}
                                                                                            />
                                                                                        </div>
                                                                                        <div className='file_text'>
                                                                                            <p>{data.file_name}</p>
                                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                                        </div>
                                                                                        {/* <span> */}
                                                                                        {/*data.file_name*/}
                                                                                        {/* {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`} */}
                                                                                        {/* </span> */}
                                                                                    </div>
                                                                                    {/* <div className='file_attch'>
                                                                                                                <div className='file_icon'>
                                                                                                                    <FontAwesomeIcon icon={faFileLines} />
                                                                                                                </div>
                                                                                                                <div className='file_text'>
                                                                                                                    <p>{baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 20)}... .${extension}`}</p>
                                                                                                                    <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                                                                </div>
                                                                                                            </div> */}
                                                                                </td>
                                                                                <td><p>{data.category[0]}</p></td>
                                                                                <td>
                                                                                    <p>{data.modified_name}</p>
                                                                                    <span>{data.modified_email}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span>{data.last_modified}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <Dropdown>
                                                                                        <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                                            <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                                        </Dropdown.Toggle>

                                                                                        <Dropdown.Menu>
                                                                                            {/* <Dropdown.Item href="#/action-1">Edit</Dropdown.Item> */}
                                                                                            <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                                            <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                                        </Dropdown.Menu>
                                                                                    </Dropdown>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })}
                                                            </tbody>
                                                        </Table>
                                                    </Tab>
                                                </Tabs>
                                            </div>
                                        </>
                                    }

                                    {selectedButton === 'remarks' &&
                                        <>
                                            <div className='chat_bg'>
                                                <div className='flbg right_side record_remarks'>
                                                    <div className='chat_box'>
                                                        {formData?.remarks?.map((msg, index) => (
                                                            <>
                                                                <Accordion key={index} activeKey={expandedKeys}>
                                                                    <Accordion.Item eventKey={index.toString()}>
                                                                        <Accordion.Header onClick={() => toggleAccordionItem(index, msg, 'all')} className=''>
                                                                            <div className='position-relative'><img src={Pack} /> {msg.created_by}</div>
                                                                            <div className='acorright'> {msg.attachments?.length > 0 && <FontAwesomeIcon icon={faPaperclip} />} <span>{msg.date} | {msg.time}</span></div></Accordion.Header>
                                                                        <Accordion.Body>
                                                                            {msg.message}
                                                                            {msg.attachments?.length > 0 &&
                                                                                <div className='d-flex mt-1 '>
                                                                                    {msg.attachments?.map((file, index) => {
                                                                                        const fileName = file?.file_name;
                                                                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                                        const extension = fileName?.split(".").pop();
                                                                                        return (
                                                                                            <>
                                                                                                <div key={`ns_${index}`} className="mag_image">
                                                                                                    {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                                                    ) ? (
                                                                                                        <>
                                                                                                            <img
                                                                                                                src={file.file_path}
                                                                                                                alt="Preview"
                                                                                                                className=''
                                                                                                                style={{
                                                                                                                    maxWidth: "30px",
                                                                                                                    maxHeight: "30px",
                                                                                                                    marginRight: "5px",
                                                                                                                }}
                                                                                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                                            // onClick={() =>
                                                                                                            //     handleFileClick(file.file_path)
                                                                                                            // }
                                                                                                            />
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <span className="d-flex rafilename">
                                                                                                                <img src={Docmnt} className="fileimg" />
                                                                                                            </span>
                                                                                                        </>
                                                                                                    )}
                                                                                                    <span className="rafilename">
                                                                                                        {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                                                    </span>
                                                                                                    <button
                                                                                                        className="msg_download"
                                                                                                        type="button"
                                                                                                        onClick={() =>
                                                                                                            handleDownload(file.file_path, file.file_name)
                                                                                                        }
                                                                                                    >
                                                                                                        <FontAwesomeIcon icon={faFileArrowDown} />
                                                                                                    </button>
                                                                                                </div>
                                                                                            </>
                                                                                        );
                                                                                    })}
                                                                                </div>
                                                                            }
                                                                        </Accordion.Body>
                                                                    </Accordion.Item>
                                                                </Accordion>
                                                            </>
                                                        ))}
                                                    </div>
                                                    <div>
                                                        <Form.Group className='massge_text'>
                                                            <div className='mag_send'>
                                                                <Link to='#' onClick={handleBrowseFiles}> <FontAwesomeIcon icon={faPaperclip} /> </Link>
                                                                {/* <Button variant="primary" onClick={() => sendMessage(selectedButton)} ><FontAwesomeIcon icon={faPaperPlane} /></Button> */}
                                                                {/* <button className='btn btn-primary drpbtn'>Browse Files</button> */}
                                                                <input
                                                                    type="file"
                                                                    ref={fileInputRef}
                                                                    style={{ display: 'none' }}
                                                                    onChange={(e) => handleFileChange(e, 'R')}
                                                                    multiple
                                                                />
                                                            </div>
                                                            <div className='d-flex reco_image'>
                                                                {rfiles.map((file, index) => {
                                                                    const fileName = file?.file_name;
                                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                    const extension = fileName?.split(".").pop();
                                                                    return (
                                                                        <div key={index} className='img-thumbnail'>
                                                                            {file?.type?.startsWith('image/') ? (
                                                                                <img
                                                                                    // src={URL.createObjectURL(file)}
                                                                                    src={file.base64}
                                                                                    alt="Preview"
                                                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                                                />
                                                                            ) : (
                                                                                <span className=''><img src={Docmnt} className='fileimg' />  </span>
                                                                            )}
                                                                            <span className="rafilename">
                                                                                {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                            </span>
                                                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index, 'R')}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                            <div>
                                                                <Form.Control
                                                                    as="textarea"
                                                                    placeholder='Enter a description...'
                                                                    rows={2}
                                                                    name='message'
                                                                    onChange={conversationChange}
                                                                    value={sendData?.message || ''}
                                                                // disabled={isSwitchOn === true}
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showModalUpload} onHide={closeModalUpload} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                    <div className='modal-title h4'>Upload Attachments</div>
                    <p className='text-start'>Drag and drop or browse to upload your attachments.</p>
                </Modal.Header>
                <Modal.Body>
                    <div className='type_work'>

                        <div className='ra_condition'>
                            <div
                                className='dropfile'
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                            >
                                <img src={Shipupload} alt="upload" />
                                <h3>Drag and drop files here</h3>
                                <p>Or</p>
                                <button className='btn btn-primary drpbtn' onClick={uploadTarget ? (e) => handleBrowseFiles(e, uploadTarget) : handleBrowseFiles}>Browse Files</button>
                                <span>Maximum file size 25 MB</span>
                                <input
                                    type="file"
                                    ref={(el) => {
                                        if (uploadTarget) {
                                            fileInputRefs.current[uploadTarget] = el;
                                        }
                                    }}
                                    style={{ display: 'none' }}
                                    onChange={uploadTarget ? (e) => handleFileChange(e, 'C', uploadTarget) : (e) => handleFileChange(e, 'A')}
                                    multiple
                                />
                            </div>
                            <div className='attach_shipment'>
                                {files.map((file, index) => (
                                    <div key={index} className='uploadfil'>
                                        {file.base64.includes('image') ? (
                                            <>
                                                <img
                                                    src={file.base64}
                                                    alt="Preview"
                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                />
                                                <span>{file.file_name}</span>
                                            </>
                                        ) : (
                                            <>  <img src={Docmnt} className='fileimg' /> <span> {file.file_name}</span> </>
                                        )}
                                        <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="primary" onClick={imageUpload}>
                            Upload
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={typeModal} onHide={() => { setTypeModal(false); }} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>{modalSection === 'S' ? 'Attachment Type' : 'Remove Attachment'}</h3>
                    <p>{modalSection === 'S' ? 'Update this attachment type' : 'Are you sure you want delete this attachment?'}</p>
                    {modalSection === 'S' &&
                        <Form.Group className="me-2">
                            <Form.Select aria-label="Select" onChange={(e) => modalChange(e)} value={typeData || "0"}>
                                <option value="0">Select</option>
                                <option value="Invoice">Invoice</option>
                                <option value="Packinglist">Packinglist</option>
                                <option value="Emails">Emails</option>
                                <option value="HAWB">HAWB</option>
                                <option value="MAWB">MAWB</option>
                                <option value="Manifest">Manifest</option>
                                <option value="Customs">Customs</option>
                                <option value="Proposal">Proposal</option>
                                <option value="Other">Other</option>
                            </Form.Select>
                        </Form.Group>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        {modalSection === 'S' ?
                            <Button variant="primary" onClick={modalUpdate}>
                                Update
                            </Button>
                            :
                            <>
                                <Button variant="secondary" onClick={() => setTypeModal(false)}>
                                    No
                                </Button>
                                <Button variant="primary" onClick={modalUpdate}>
                                    Yes
                                </Button>
                            </>
                        }
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={showModal} onHide={() => { setShowModal(false); }} className='addfrom change_type' centered>

                <Modal.Header closeButton>
                    <Modal.Title className='text-center'> <h4>Send Notifications</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul className="list-unstyled">

                        <li>
                            <span>Reminder date :</span>
                            <span>
                                <Form.Control
                                    type="datetime-local"
                                    name="reminder_date"
                                    placeholder="Select Date"
                                    value={formData.reminder_date || ''}
                                    onChange={(e) => handleFieldChange('reminder_date', e.target.value)}
                                />
                            </span>
                        </li>

                        <li>
                            <span>Overdue notif. :</span>
                            <span>
                                <Form.Control
                                    type="datetime-local"
                                    name="overdue_notif"
                                    placeholder="Overdue notif"
                                    value={formData?.overdue_notif ? `${formData.overdue_notif}T00:00` : ''}
                                    onChange={(e) => handleFieldChange('overdue_notif', e.target.value)}
                                />
                            </span>
                        </li>


                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>

                        <Button variant="primary" onClick={() => handleApply()} >
                            Apply
                        </Button>

                    </div>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default EditTask;

